<footer data-ui-view="footer" class="footer">
    <div class="grid-container grid-container--section" data-footer-fixed="">
        <nav class="footer__navigation">
            <ul class="footer__menu">
                <li class="footer__menuLink">
                    <a id="legalModal" data-tag-commander="" [appTagCommander]="'tagCo.footer.legalmention.button'" (click)="displayLegalesModal = !displayLegalesModal" class="footer-navLink">{{ 'footer.navigation.item1' | i18n }}</a>
                </li>
                <li class="footer__menuLink">
                    <a id="PrivacyModal" data-tag-commander="" [appTagCommander]="'tagCo.footer.cnil.button'" (click)="displayPrivacyModal = !displayPrivacyModal" class="footer-navLink">{{ 'footer.navigation.item2' | i18n }}</a>
                </li>
                <li class="footer__menuLink">
                    <a id="cookiesModal" data-tag-commander="" [appTagCommander]="'tagCo.footer.cookies.button'" (click)="openPrivacyCenter()" class="footer-navLink">
                        {{ 'footer.navigation.item3' | i18n }}
                    </a>
                </li>
                <li class="footer__menuLink">
                    <a id="accesibilite"
                       (click)="displayAccesibilite = !displayAccesibilite" class="footer-navLink">
                        {{ 'footer.navigation.item4' | i18n }}
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</footer>
<app-modal-component [modalTitle]="'footer.legalmention.title' | i18n" [content]="'footer.legalmention.text' | i18n | safeHtml" [(visibility)]="displayLegalesModal"></app-modal-component>
<app-modal-component [modalTitle]="'footer.cookies.title' | i18n" [content]="'footer.cookies.text' | i18n | safeHtml" [(visibility)]="displayPrivacyModal"></app-modal-component>
<app-modal-component [modalTitle]="'footer.accesibilite.title' | i18n" [content]="'footer.accesibilite.text' | i18n" [(visibility)]="displayAccesibilite"></app-modal-component>
